import {
  memo,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import MuxVideo from "@mux/mux-video-react";
import "media-chrome";
// import "media-chrome/dist/extras/media-clip-selector";

import playerTheme from "./MuxPlayer.module.scss";
import backBtnImg from "../../assets/images/ArrowLeft.png";
import notesImg from "../../assets/images/notes.png";
import settingIcon from "../../assets/images/settings.png";
import watchLaterImg from "../../assets/images/watchLater.png";
import packageInfo from "../../../package.json";

import { THEME } from "../../AppConstants/ThemeConstant.js";
import { getOS, isMobileDevice } from "../../utils/getPlatformInfo";
import { VideoPlayerContext } from "../../contexts/VideoPlayerContext/VideoPlayerContextProvider";
import { isProd, trimString } from "../../utils/common.utils";
import ScoreManager from "../../Managers/ScoringManager/post";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import {
  ASSETS_BASE_URL,
  PLAYER_EVENT_DEBOUNCE_IN_SEC,
} from "../../AppConstants/Constants";
import VideoSpeedController from "./VideoSpeedController";
import { updateLandingPageSession } from "../../firebase/firebase.js";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider.js";
import {
  PLAYER_ENDED_EVENT,
  PLAYER_ERROR_EVENT,
  PLAYER_FULLSCREEN_EVENT,
  PLAYER_PAUSE_EVENT,
  PLAYER_PLAY_EVENT,
  PLAYER_SEEK_EVENT,
  PLAYER_TIMEUPDATE_EVENT,
  SKIP_INTRO_CLICK_EVENT,
} from "../../Clevertap/EventNames.ts";
import {
  getStandaloneVideoData,
  getWebinarClickData,
} from "../../Clevertap/EventHandler.ts";
import { VIDEO_PLAYER_ERROR } from "../../AppConstants/AnalyticsEventName.js";

// const skipArrowIcon = `${ASSETS_BASE_URL}/images/skipArrow.png`;
const attributes = {
  autohide: 2,
  autoplay: false,
  muted: false,
  streamType: "on-demand", //"on-demand", "live" (HLS live stream), "ll-live" (low latency live)
};
const envKey =
  window.location.hostname === "docflix.com"
    ? "ou7u7a38cm4h875fk5tfe6h9l"
    : "pip1urc2vg8l2d98d2ol6ol36";
let debounce = true;

const generateVTT = (chapters) => {
  try {
    let vtt = "WEBVTT\n\n";
    chapters.forEach((chapter) => {
      const start = new Date(chapter.startTime * 1000)
        .toISOString()
        .substring(11, 23);
      const end = new Date(chapter.endTime * 1000).toISOString().substring(11, 23);
      vtt += `${start} --> ${end}\n${chapter.title}\n\n`;
    });
    const vttBlob = new Blob([vtt], { type: "text/vtt" });
    const vttUrl = URL.createObjectURL(vttBlob);
    return vttUrl;
  } catch (error) {
    console.log(error);
    return null
    
  }
};

const MuxVideoPlayer = ({
  playNextEpisode,
  cancelled = false,
  checkForPremium = () => { },
  isSidePanelOpen,
  isWatchLaterVideo,
  handleNoteBtn,
  handleWatchLaterBtn,
  closeStartWatchingBtn,
  handleVideoLoading,
  startingPoint,
  videoData,
  showPlayer,
  muxVideoRef,
  themeType,
  allNotes,
  allChapters,
  speedControlToggleCB = () => { },
}) => {
  const { id, playbackid, title, tokens, ongoingagendaid = null } = videoData;
  const { user } = useContext(UserContext);
  const { addCleverTapAnalytics, addGAWithNoUser } = useContext(AnalyticsContext);
  const userid = user ? user.uid : null;

  const { isFullScreen, handleFullScreen } = useContext(VideoPlayerContext);
  const { toggleSignInbtn } = useContext(authContext);
  const { globalDocflixConstant, userInterected } =
    useContext(ConstantDataContext);

  const [bookMark, setBookMark] = useState({});
  const [showRemaining, setShowRemaining] = useState(true);
  const [currentVideoTime, setCurrentVideoTime] = useState(0);
  const [openSettings, setOpenSettings] = useState(false);
  const [currentRate, setCurrentRate] = useState(1);
  const videoScoreGiven = useRef({ id: id, scored: false });
  const skipBtnVisible = useRef({ id: id, visible: false });
  const outroBtnVisible = useRef({ id: id, visible: false });
  const skipBtnRef = useRef(null);
  const outroBtnRef = useRef(null);
  const initialPlay = useRef(false);
  const [showBookmarkBar, setShowBookmarkBar] = useState(false);
  const [visibleSegment, setVisibleSegment] = useState(null);
  const isSegmentesPlasedRef = useRef(false);

  const mediaClipSelect = document.querySelector("media-clip-selector");

  useEffect(() => {
    const handleTimeUpdate = (e) => {
      if (muxVideoRef.current.paused || !muxVideoRef.current.currentTime) {
        return;
      }
      // if (
      //   parseInt(muxVideoRef.current.currentTime) %
      //     PLAYER_EVENT_DEBOUNCE_IN_SEC ===
      //     0 &&
      //   debounce
      // ) {
      //   debounce = false;
      //   if (themeType === THEME.EVENT_THEME) {
      //     addLogEvents(
      //       PLAYER_TIMEUPDATE_EVENT,
      //       getWebinarClickData(videoData)
      //     );
      //   } else {
      //     addLogEvents(
      //       PLAYER_TIMEUPDATE_EVENT,
      //       getStandaloneVideoData(videoData)
      //     );
      //   }

      //   setTimeout(() => {
      //     debounce = true;
      //   }, PLAYER_EVENT_DEBOUNCE_IN_SEC * 1000);
      // }
      setCurrentVideoTime(muxVideoRef.current.currentTime);
      // setCurrentVideoTime(Math.round(muxVideoRef.current.currentTime));
    };

    const handleSeeked = (e) => {
      if (themeType === THEME.EVENT_THEME) {
        // addLogEvents(PLAYER_SEEK_EVENT, getWebinarClickData(videoData));
      } else {
        addLogEvents(PLAYER_SEEK_EVENT, getStandaloneVideoData(videoData));
      }
    };

    const handleError = (e) => {
      if (!e?.detail?.message) {
        return;
      }
      addGAWithNoUser(VIDEO_PLAYER_ERROR, {
        theme: themeType,
        message: e?.detail?.message
      })
      if (themeType === THEME.EVENT_THEME) {
        if (e.detail?.code == 5) {
          addLogEvents(PLAYER_ERROR_EVENT, {
            Message: e?.detail?.message,
            ...getWebinarClickData(videoData),
          });
        }
      } else {
        addLogEvents(PLAYER_ERROR_EVENT, {
          Message: e?.detail?.message,
          ...getStandaloneVideoData(videoData),
        });
      }
    };

    const handlePause = (e) => {
      if (themeType === THEME.EVENT_THEME) {
        // addLogEvents(PLAYER_PAUSE_EVENT, getWebinarClickData(videoData));
      } else {
        addLogEvents(PLAYER_PAUSE_EVENT, getStandaloneVideoData(videoData));
      }
      if (
        themeType === THEME.VIDEO_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME ||
        themeType === THEME.EVENT_ENDED_THEME
      ) {
        updateScoreAndTime();
      }
      if (themeType === THEME.CHAPTER_ON_DEMAND_THEME) {
        let academyOverlay = document.querySelector("#pauseOverlay");
        if (academyOverlay) {
          academyOverlay.style.display = "block";
        }
      }
    };

    const handleEnded = async (e) => {
      if (themeType === THEME.EVENT_THEME) {
        // addLogEvents(PLAYER_ENDED_EVENT, getWebinarClickData(videoData));
      } else {
        addLogEvents(PLAYER_ENDED_EVENT, getStandaloneVideoData(videoData));
      }
      if (
        themeType === THEME.VIDEO_THEME ||
        themeType === THEME.EVENT_ENDED_THEME
      ) {
        updateLandingPageSession();
        if (!user) {
          toggleSignInbtn("showSignInModal", true);
        }
      }
      if (
        themeType === THEME.VIDEO_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME
      ) {
        skipBtnVisible.current.visible = false;
        outroBtnVisible.current.visible = false;

        updateScoreAndTime(true);

        if (
          themeType === THEME.VIDEO_THEME ||
          themeType === THEME.CHAPTER_ON_DEMAND_THEME
        ) {
          if (playNextEpisode) {
            playNextEpisode();
          }
        }
      }
    };

    const handlePlay = async (e) => {
      // if (themeType === THEME.VIDEO_THEME && !user) {
      //   toggleSignInbtn("showSignInModal", true);
      //   return;
      // }

      if (themeType === THEME.EVENT_THEME) {
        // addLogEvents(PLAYER_PLAY_EVENT, getWebinarClickData(videoData));
      } else {
        addLogEvents(PLAYER_PLAY_EVENT, getStandaloneVideoData(videoData));
      }

      if (themeType === THEME.EVENT_THEME) {
        if (!muxVideoRef.current.paused) {
          seekTo(muxVideoRef.current.duration);
        }
      } else if (
        themeType === THEME.VIDEO_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME
      ) {
        if (!initialPlay.current && muxVideoRef.current.duration) {
          let SessionTime = sessionStorage.getItem(id);
          if (
            Math.floor(startingPoint) !==
            Math.floor(muxVideoRef.current.duration)
          ) {
            seekTo(SessionTime ? +SessionTime : startingPoint);
            sessionStorage.clear(id);
          } else {
            muxVideoRef.current.currentTime = 0;
          }
          initialPlay.current = true;
        }

        if (themeType === THEME.CHAPTER_ON_DEMAND_THEME) {
          let academyOverlay = document.querySelector("#pauseOverlay");
          if (academyOverlay) {
            academyOverlay.style.display = "none";
          }
        }
      }
    };

    const handleLoadedmetadata = (e) => {
      document.dispatchEvent(new CustomEvent("ViewContent"));
      if (themeType === THEME.CHAPTER_ON_DEMAND_THEME) {
        closeStartWatchingBtn(
          muxVideoRef.current.duration,
          muxVideoRef.current.currentTime,
          false,
          "loaded"
        );
      } else {
        closeStartWatchingBtn(
          muxVideoRef.current.duration,
          muxVideoRef.current.currentTime,
          "loaded"
        );
      }
      if (
        themeType === THEME.VIDEO_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME
      ) {
        getSubtitles();
        let _subtitleBtnRef =
          document.querySelectorAll("#subtitles")[isMobileDevice ? 1 : 0];

        let _subtitleMenu =
          document.getElementsByClassName("subtitles-menu")[0];

        _subtitleBtnRef.addEventListener("click", (e) => {
          if (_subtitleMenu) {
            _subtitleMenu.style.display =
              _subtitleMenu.style.display === "block" ? "none" : "block";
          }
        });
      }
      if (handleVideoLoading) {
        handleVideoLoading(false);
      }
    };

    if (muxVideoRef.current) {
      muxVideoRef.current.addEventListener(
        "loadedmetadata",
        handleLoadedmetadata
      );

      muxVideoRef.current.addEventListener("play", handlePlay);
      muxVideoRef.current.addEventListener("ended", handleEnded);
      muxVideoRef.current.addEventListener("pause", handlePause);
      muxVideoRef.current.addEventListener("error", handleError);
      muxVideoRef.current.addEventListener("seeked", handleSeeked);
      muxVideoRef.current.addEventListener("timeupdate", handleTimeUpdate);
    }
    // playbtn UI updation

    // let playbtn = document.querySelector("media-play-button");
    // if (playbtn && playbtn.shadowRoot) {
    //   console.log("DS", playbtn.shadowRoot.querySelector("slot[name=play]"));
    //   console.log("DS", playbtn.shadowRoot.querySelector("slot[name=pause]"));
    // }

    if (mediaClipSelect && mediaClipSelect.shadowRoot) {
      mediaClipSelect.addEventListener("update", (evt) => {
        const { startTime, endTime } = evt.detail;
        setBookMark({ start: startTime, end: endTime });
      });

      // overide time frame css
      mediaClipSelect.shadowRoot
        .querySelector("#thumbnailContainer")
        .setAttribute("style", "top:unset");
      mediaClipSelect.shadowRoot
        .querySelector("#selectorContainer")
        .querySelector("#selection")
        .querySelector("#startHandle")
        .setAttribute("style", "background-color:#eb4547");

      mediaClipSelect.shadowRoot
        .querySelector("#selectorContainer")
        .querySelector("#selection")
        .querySelector("#spacer")
        .setAttribute("style", "background-color:#eb4547");

      mediaClipSelect.shadowRoot
        .querySelector("#selectorContainer")
        .querySelector("#selection")
        .querySelector("#endHandle")
        .setAttribute("style", "background-color:#eb4547");
    }

    return () => {
      if (muxVideoRef.current) {
        muxVideoRef.current.removeEventListener(
          "loadedmetadata",
          handleLoadedmetadata
        );

        muxVideoRef.current.removeEventListener("play", handlePlay);
        muxVideoRef.current.removeEventListener("ended", handleEnded);
        muxVideoRef.current.removeEventListener("pause", handlePause);
        muxVideoRef.current.removeEventListener("error", handleError);
        muxVideoRef.current.removeEventListener("seeked", handleSeeked);
        muxVideoRef.current.removeEventListener("timeupdate", handleTimeUpdate);
      }
    };
  }, [id]);

  useEffect(() => {
    return () => updateScoreAndTime();
  }, [cancelled]);

  useEffect(() => {
    if (!currentVideoTime) {
      return;
    }
    if (
      themeType === THEME.VIDEO_THEME ||
      themeType === THEME.EVENT_ENDED_THEME ||
      themeType === THEME.CHAPTER_ON_DEMAND_THEME
    ) {
      // check for globally enable or not intro btn
      if (globalDocflixConstant) {
        if (globalDocflixConstant?.videos?.skipBtnToggle) {
          // check for individually video's intro btn
          if (videoData.showSkipButton) {
            handleShowSkipBtn();
          }
        }
        if (globalDocflixConstant?.videos?.outroBtnToggle) {
          // check for individually video's intro btn
          if (videoData.showOutroButton) {
            handleShowOutroBtn();
          }
        }
      }
      if (themeType === THEME.VIDEO_THEME) {
        checkForPremium(currentVideoTime);
        if (currentVideoTime > 2) {
          sessionStorage.setItem(id, currentVideoTime);
        }
      }
    }
  }, [globalDocflixConstant, currentVideoTime]);

  useEffect(() => {
    // Set the markers when we CAN know the duration of the video.
    if (
      muxVideoRef?.current &&
      allNotes &&
      allNotes.content &&
      (themeType === THEME.VIDEO_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME)
    ) {
      addMarkers(allNotes.content);
    }
  }, [muxVideoRef.current, allNotes, id]);

  const addMarkers = (positions) => {
    // Create some CSS to apply to the shadow dom
    let style = document.createElement("style");

    style.textContent = `
    .bubbles {
      background-color: #ffed4f !important;
      position: absolute;
      height: 5px;
      width: 7px;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
    }
    .bubbles:after {
      display: none;
      content: attr(data-content);
      position: absolute;
      bottom: 300%;
    }
    .bubbles:hover:after {
      display: block;
    }`;

    // seekbar
    const seekBar =
      document.querySelectorAll("media-time-range")[isMobileDevice ? 1 : 0]
        .shadowRoot;
    seekBar.prepend(style);
    // Existing markers
    const existingMarkers = seekBar.querySelectorAll(".bubbles");

    // Remove markers not in the current positions
    existingMarkers.forEach((marker) => {
      const markerId = marker.getAttribute("data-id");
      if (!positions.some((position) => position.id === markerId)) {
        marker.remove();
      }
    });

    // Add each marker to the seekbar
    positions.forEach((position) => {
      // Check if the marker already exists
      const existingMarker = seekBar.querySelector(
        `.bubbles[data-id="${position.id}"]`
      );

      // Skip creating if it already exists
      if (existingMarker) return;

      // Is position within range of the duration?
      if (position.startTime <= muxVideoRef.current.duration) {
        // Calculate position in percentage
        const left =
          (position.startTime / muxVideoRef.current.duration) * 100 + "%";

        // Create marker and set attributes
        const marker = document.createElement("div");
        marker.setAttribute("data-content", trimString(position.note, 50));
        marker.setAttribute("data-id", position.id);
        marker.classList.add("bubbles");
        marker.style.left = left;

        // Set onclick event
        marker.onclick = () =>
          (muxVideoRef.current.currentTime = position.startTime);

        // Add the marker to the seekbar
        seekBar.appendChild(marker);
      }
    });
  };

  const togglePause = (e) => {
    if (!muxVideoRef.current.paused) {
      muxVideoRef.current.pause();
    } else {
      muxVideoRef.current.play();
    }
  };

  useEffect(() => {
    if (
      (themeType === THEME.VIDEO_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME) &&
      allChapters &&
      currentVideoTime
    ) {
      getSegmentText();
    }
  }, [currentVideoTime, allChapters, id]);

  const handleBookMarkButton = () => {
    setShowBookmarkBar((prev) => !prev);
  };

  const addVideoScore = () => {
    if (muxVideoRef.current && videoScoreGiven.current) {
      const { id, scored } = videoScoreGiven.current;
      if (id === videoData.id) {
        let percentage =
          (muxVideoRef.current.currentTime / muxVideoRef.current.duration) *
          100;

        if (
          Math.floor(percentage) >= 70 &&
          (themeType === THEME.VIDEO_THEME ||
            themeType === THEME.EVENT_ENDED_THEME) &&
          !scored &&
          userid
        ) {
          videoScoreGiven.current.scored = true;

          ScoreManager.watchedContent(videoData.id, userid);
        } else {
        }
      }
    }
  };

  const handleShowSkipBtn = () => {
    if (skipBtnVisible.current) {
      const { id, visible } = skipBtnVisible.current;
      if (id === videoData.id && videoData.skipDuration && skipBtnRef.current) {
        // show button only once add && !visible
        if (currentVideoTime < videoData.skipDuration) {
          skipBtnRef.current.classList.add(playerTheme.skipBtnFadeIn);
          skipBtnRef.current.style.opacity = 1;
          skipBtnRef.current.style.pointerEvents = "all";
        } else {
          hideSkipBtn();
        }
      }
    }
  };

  const handleShowOutroBtn = () => {
    if (outroBtnVisible.current) {
      const { id, visible } = outroBtnVisible.current;
      if (
        id === videoData.id &&
        videoData.outroDuration &&
        outroBtnRef.current
      ) {
        // show button only once add && !visible
        if (
          currentVideoTime < muxVideoRef.current.duration &&
          currentVideoTime > videoData.outroDuration
        ) {
          outroBtnRef.current.classList.add(playerTheme.skipBtnFadeIn);
          outroBtnRef.current.style.opacity = 1;
          outroBtnRef.current.style.pointerEvents = "all";
        } else {
          hideOutroBtn();
        }
      }
    }
  };
  const handleVideoBackBtn = () => {
    // close full Screen
    isFullScreen && handleFullScreen();
    if (cancelled) {
      muxVideoRef.current.currentTime = 0;
    }
    if (muxVideoRef.current) {
      closeStartWatchingBtn(
        muxVideoRef.current.duration,
        muxVideoRef.current.currentTime,
        "backbtn"
      );
    } else {
      closeStartWatchingBtn();
    }
    if (
      themeType === THEME.VIDEO_THEME ||
      themeType === THEME.EVENT_ENDED_THEME
    ) {
      addVideoScore();
    }
  };

  const updateScoreAndTime = (ended = false) => {
    if (cancelled) {
      muxVideoRef.current.currentTime = 0;
    }
    let _time = 0;
    if (ended) {
      _time = muxVideoRef.current.duration;
    } else {
      _time = muxVideoRef.current.currentTime;
    }

    if (themeType === THEME.CHAPTER_ON_DEMAND_THEME) {
      closeStartWatchingBtn(
        muxVideoRef.current.duration,
        _time,
        ended,
        "pausebtn"
      );
    } else {
      closeStartWatchingBtn(muxVideoRef.current.duration, _time, "pausebtn");
    }

    if (themeType !== THEME.CHAPTER_ON_DEMAND_THEME) {
      addVideoScore();
    }
  };
  const handleFullScreenButton = () => {
    if (themeType === THEME.EVENT_THEME) {
      addLogEvents(PLAYER_FULLSCREEN_EVENT, getWebinarClickData(videoData));
    } else {
      addLogEvents(PLAYER_FULLSCREEN_EVENT, getStandaloneVideoData(videoData));
    }
    let os = getOS();
    if (os === "Android") {
      return;
    }
    muxVideoRef.current?.webkitEnterFullscreen();
  };

  const getSegmentText = () => {
    for (let i = 0; i < allChapters.length; i++) {
      if (
        currentVideoTime >= allChapters[i].startTime &&
        allChapters[i].endTime >= currentVideoTime
      ) {
        // let segment = allChapters[i].title;
        setVisibleSegment(allChapters[i]);
        break;
      }
    }
  };

  const seekTo = (seconds) => {
    if (muxVideoRef && muxVideoRef.current && !isNaN(seconds)) {
      muxVideoRef.current.currentTime = seconds;
    }
  };
  const getVideoBigSegment = (segment, index) => {
    // Is position within range of the duration?
    if (segment.startTime <= muxVideoRef.current.duration) {
      // Calculate position in percentage..
      const left =
        (segment.startTime / muxVideoRef.current.duration) * 100 + "%";
      const width =
        ((segment.endTime - segment.startTime) / muxVideoRef.current.duration) *
        100 +
        "%";
      return (
        <div
          className={playerTheme.tiles}
          style={{
            left: left,
            width: width,
            backgroundColor:
              visibleSegment && visibleSegment.title === segment.title
                ? "var(--primary-color2)"
                : "#000",
          }}
          onClick={() => seekTo(segment.startTime + 1)}
          key={index}
        >
          <div className={playerTheme.tilesText}>
            {trimString(segment.title, 40)}
          </div>
        </div>
      );
    }
  };
  const handleSkipBtn = () => {
    if (muxVideoRef.current) {
      seekTo(videoData.skipDuration);
      muxVideoRef.current.play();
      hideSkipBtn();
    }

    addCleverTapAnalytics(
      SKIP_INTRO_CLICK_EVENT,
      getStandaloneVideoData(videoData)
    );
  };

  const hideSkipBtn = () => {
    if (skipBtnRef.current) {
      if (skipBtnVisible.current) {
        skipBtnVisible.current.visible = true;
      }
      skipBtnRef.current.classList.remove(playerTheme.skipBtnFadeIn);
      skipBtnRef.current.style.opacity = 0;
      skipBtnRef.current.style.pointerEvents = "none";
    }
  };

  const handleOutroBtn = () => {
    if (muxVideoRef.current) {
      seekTo(muxVideoRef.current.duration);
      hideOutroBtn();
    }
  };

  const hideOutroBtn = () => {
    if (outroBtnRef.current) {
      if (outroBtnVisible.current) {
        outroBtnVisible.current.visible = true;
      }
      outroBtnRef.current.classList.remove(playerTheme.skipBtnFadeIn);
      outroBtnRef.current.style.opacity = 0;
      outroBtnRef.current.style.pointerEvents = "none";
    }
  };
  const updateRate = useCallback(
    (rate) => {
      if (muxVideoRef.current) {
        muxVideoRef.current.playbackRate = rate;
        setCurrentRate(rate);
      }
    },
    [muxVideoRef]
  );
// console.log("opensettings",openSettings);

useEffect(() => {
  if(speedControlToggleCB){
    speedControlToggleCB(openSettings);}
}, [openSettings]);

  const toggleSettings = useCallback(() => {
    setOpenSettings((prev) => {
      let _prev = !prev;
    //   console.log("changing");
      if (speedControlToggleCB) {
        
        speedControlToggleCB(_prev);
      }
      return _prev;
    });
  }, []);

  const getSubtitles = () => {
    if (!muxVideoRef.current || !muxVideoRef.current.textTracks) {
      let _subtitleBtnRef =
        document.querySelectorAll("#subtitles")[isMobileDevice ? 1 : 0];
      _subtitleBtnRef.style.display = "none";
      return;
    }
    if (muxVideoRef.current && muxVideoRef.current.textTracks) {
      const df = document.createDocumentFragment();
      const subtitlesMenu = df.appendChild(document.createElement("ul"));
      subtitlesMenu.className = "subtitles-menu";

      subtitlesMenu.appendChild(createMenuItem("subtitles-off", "", "Off"));
      for (let i = 1; i < muxVideoRef.current.textTracks.length; i++) {
        let _sub = muxVideoRef.current.textTracks[i];
        if (_sub.kind !== "metadata") {
          _sub.oncuechange = () => {
            // console.log(_sub);
            for (let z = _sub.cues.length - 1; z > -1; z--) {
              // if (_sub.cues[z].line === -3) break;
              _sub.cues[z].line = -4;
            }
          };
          subtitlesMenu.appendChild(
            createMenuItem(
              `subtitles-${_sub.language}`,
              _sub.language,
              _sub.label
            )
          );
        }
      }

      let _subtitleBtnRef =
        document.querySelectorAll("#subtitles")[isMobileDevice ? 1 : 0];
      if (subtitlesMenu.getElementsByTagName("li").length > 1) {
        document
          .querySelector(`.${playerTheme["media-theme-docflix"]}`)
          .appendChild(subtitlesMenu);
        _subtitleBtnRef.style.display = "block";
      } else {
        _subtitleBtnRef.style.display = "none";
        return;
      }
    }

    function createMenuItem(id, lang, label) {
      const listItem = document.createElement("li");
      const button = listItem.appendChild(document.createElement("button"));
      button.setAttribute("id", id);
      button.className = "subtitles-button";
      if (lang.length > 0) button.setAttribute("lang", lang);
      button.value = label;
      button.setAttribute("data-state", "inactive");
      button.style.background = "#0a2347";
      button.appendChild(document.createTextNode(label));
      button.addEventListener("click", (e) => {
        // Find the language to activate
        const lang = button.getAttribute("lang");

        const allButtons = document.querySelectorAll(".subtitles-button");

        // reset all the buttons color
        for (let i = 0; i < allButtons.length; i++) {
          let _sub = allButtons[i];
          _sub.style.background = "#0a2347";
          _sub.setAttribute("data-state", "inactive");
        }

        for (let i = 0; i < muxVideoRef.current.textTracks.length; i++) {
          let _sub = muxVideoRef.current.textTracks[i];

          if (_sub.kind !== "metadata") {
            // For the 'subtitles-off' button, the first condition will never match so all will subtitles be turned off
            if (_sub.language === lang) {
              _sub.mode = "showing";
              button.setAttribute("data-state", "active");
              button.style.background = "var(--primary-color2)";
              // _sub.activeCues[0].line = -4;
              //   console.log(_sub);
            } else {
              _sub.mode = "hidden";
            }
          }
        }
        document.getElementsByClassName("subtitles-menu")[0].style.display =
          "none";
      });
      return listItem;
    }
  };

  const addLogEvents = (eventName, data = {}) => {
    let baseObj = {
      Player: "mux-video-react",
      "Player Version": packageInfo.dependencies["@mux/mux-video-react"],
    };

    baseObj["streamtype"] =
      themeType === THEME.EVENT_THEME ? "live" : attributes.streamType;
    baseObj["Livestream"] = themeType === THEME.EVENT_THEME;

    addCleverTapAnalytics(eventName, { ...data, ...baseObj });
  };

  return (
    <media-controller
      autohide={attributes.autohide}
      class={`${playerTheme["media-theme-docflix"]} ${isMobileDevice && user && playerTheme["mobile_Player"]
        } ${showPlayer && "d-block"} ${!muxVideoRef.current.paused
          ? playerTheme["showplayer"]
          : playerTheme["hideplayer"]
        }`}
    >
      <MuxVideo
        ref={muxVideoRef}
        playbackId={`${playbackid}${tokens && tokens.videoToken && tokens.videoToken !== ""
          ? `?token=${tokens.videoToken}`
          : ``
          }`}
        // playbackId="01b2r4H6Pg8Q01NJZGppCu6X6tmfP6f6Jtp5oFZaETUwU"
        // src={`https://stream.mux.com/vo2iqzA1GmbaH29JD9k6azxTiXLI3GuwydP2wZ2C7bs.m3u8`}
        // src={`https://stream.mux.com/${playbackid}.m3u8${
        //   tokens && tokens.videoToken && tokens.videoToken !== ""
        //     ? `?token=${tokens.videoToken}`
        //     : ""
        // }`}
        // envkey={
        //   window.location.hostname.includes("docflix.com") && userid
        //     ? envKey
        //     : ""
        // }
        envkey={envKey}
        metadata={
          // userid?
          {
            video_id: id,
            video_title: title,
            viewer_user_id: userid || "anonymous",
            custom_1:
              themeType === THEME.EVENT_THEME
                ? "webinar"
                : themeType === THEME.CHAPTER_ON_DEMAND_THEME
                  ? "academy"
                  : "video",
            custom_2:
              themeType === THEME.EVENT_THEME
                ? ongoingagendaid
                : themeType === THEME.CHAPTER_ON_DEMAND_THEME
                  ? "chapter"
                  : videoData?.videoType,
          }
          // : {}
        }
        // playbackspeed={1}
        streamtype={
          themeType === THEME.EVENT_THEME ? "live" : attributes.streamType
        }
        slot="media"
        poster={`https://image.mux.com/${playbackid}/thumbnail.jpg${tokens && tokens.thumbnailToken && tokens.thumbnailToken !== ""
          ? `?token=${tokens.thumbnailToken}`
          : ``
          }`}
        preload="auto"
        crossOrigin="true"
        playsInline={true}
        autoPlay={true}
        loop={
          themeType === THEME.DOUCUMENTARY_THEME ||
          themeType === THEME.EVENT_THEME
        }
        muted={!userInterected}
        // prefermse="true"
        type="hls"
      >
        <track
          label="thumbnails"
          default
          crossOrigin="true"
          kind="metadata"
          src={`https://image.mux.com/${playbackid}/storyboard.vtt${tokens && tokens.storyBoardToken && tokens.storyBoardToken !== ""
            ? `?token=${tokens.storyBoardToken}`
            : ``
            }`}
        />
        {allChapters&&<track label="Chapters" kind="chapters" src={generateVTT(allChapters)} default />}
        {/* <track label="English" srcLang="en-us" kind="captions" src="" /> */}
      </MuxVideo>
      {/* {themeType === THEME.VIDEO_THEME && !isMobileDevice && (
        <img
          onClick={handleVideoBackBtn}
          className={playerTheme["backbtn"]}
          src={backBtnImg}
          alt="back"
        />
      )} */}
      {themeType === THEME.VIDEO_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ||
        themeType === THEME.MANKIND_STANDALONE_THEME ? (
        <div className="overlay" slot="centered-chrome">
          <media-seek-backward-button
            seek-offset="10"
            class={`${playerTheme["seekOverlay"]}`}
          ></media-seek-backward-button>
          <media-play-button
            class={`${playerTheme["seekOverlay"]}`}
            style={{
              borderRadius:
                themeType === THEME.MANKIND_STANDALONE_THEME
                  ? "50%"
                  : // : themeType === THEME.VIDEO_THEME
                  // ? "0 50% 50% 0"
                  "",
              background:
                themeType === THEME.MANKIND_STANDALONE_THEME
                  ? "rgba(0, 0, 0, 0.3)"
                  : // : themeType === THEME.VIDEO_THEME
                  // ? "var(--primary-color2)"
                  "",
            }}
          ></media-play-button>
          <media-seek-forward-button
            seek-offset="10"
            class={`${playerTheme["seekOverlay"]}`}
          ></media-seek-forward-button>
        </div>
      ) : null}
      {themeType === THEME.EVENT_THEME && (
        <div className="overlay" slot="centered-chrome">
          <media-play-button
            // onClick={handleEventPlayBtn}
            class={`${playerTheme["seekOverlay"]}`}
            style={{
              borderRadius:
                themeType === THEME.MANKIND_STANDALONE_THEME
                  ? "50%"
                  : // : themeType === THEME.VIDEO_THEME
                  // ? "0 50% 50% 0"
                  "",
              background:
                themeType === THEME.MANKIND_STANDALONE_THEME
                  ? "rgba(0, 0, 0, 0.3)"
                  : // : themeType === THEME.VIDEO_THEME
                  // ? "var(--primary-color2)"
                  "",
            }}
          ></media-play-button>
        </div>
      )}

      {themeType === THEME.VIDEO_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ? (
        <media-control-bar class="desktop">
          <media-clip-selector
            class={`${showBookmarkBar ? "" : "d-none"}`}
          ></media-clip-selector>
          <>
            <media-time-range
              class={`${!showBookmarkBar ? "" : "d-none"}`}
            ></media-time-range>
            <div
              className={"cursor-pointer"}
              onClick={() => setShowRemaining((prev) => !prev)}
            >
              {!showRemaining ? (
                <media-time-display
                  show-duration
                  class={`${!showBookmarkBar ? "" : "d-none"}`}
                ></media-time-display>
              ) : (
                <media-time-display
                  remaining
                  class={`${!showBookmarkBar ? "" : "d-none"}`}
                ></media-time-display>
              )}
            </div>
          </>
        </media-control-bar>
      ) : null}
      {themeType === THEME.VIDEO_THEME ||
        themeType === THEME.CHAPTER_ON_DEMAND_THEME ||
        themeType === THEME.EVENT_ENDED_THEME ? (
        <>
          <media-control-bar
            class="desktop"
            style={{ background: "linear-gradient(180deg, transparent, #000)" }}
          >
            {/* slot="top-chrome" className="mobile" slot="top-chrome" */}
            <media-play-button></media-play-button>
            <media-mute-button></media-mute-button>
            <media-volume-range></media-volume-range>
            {visibleSegment && (
              <div
                className={playerTheme["segmentText"]}
                onClick={() => seekTo(visibleSegment.startTime)}
              >
                {visibleSegment.title}
              </div>
            )}
            <span className={playerTheme["control-spacer"]}></span>

            {user && handleWatchLaterBtn && themeType === THEME.VIDEO_THEME && (
              <button
                className={playerTheme["watchLaterBtn"]}
                onClick={handleWatchLaterBtn}
                style={{
                  backgroundColor: isWatchLaterVideo
                    ? "var(--primary-color2)"
                    : "transparent",
                }}
              >
                <img
                  src={watchLaterImg}
                  alt="watchLater"
                  className={playerTheme.actionImg}
                />
                Watch Later
              </button>
            )}
            {user &&
              (themeType === THEME.VIDEO_THEME ||
                themeType === THEME.CHAPTER_ON_DEMAND_THEME) && !isFullScreen && (
                <button
                  className={playerTheme["note-btn"]}
                  style={{
                    backgroundColor: isSidePanelOpen ? "#fff" : "transparent",
                    color: isSidePanelOpen ? "#000" : "#fff",
                  }}
                  onClick={handleNoteBtn}
                >
                  <img
                    src={notesImg}
                    alt="notes"
                    className={playerTheme.actionImg}
                  />
                  My Notes
                </button>
              )}
            {/* <media-playback-rate-button
              style={{ alignSelf: "center" }}
              rates={`1,1.25,1.5,1.75,2`}
            ></media-playback-rate-button> */}

            <img
              src={settingIcon}
              alt="setting"
              onClick={toggleSettings}
              className={playerTheme.settingsIcon}
            />
            <button id="subtitles" type="button" data-state="subtitles">
              CC
            </button>

            <media-fullscreen-button onClick={handleFullScreen}>
              {/* <svg slot="enter"></svg> */}
              {/* <svg slot="exit"></svg> */}
            </media-fullscreen-button>
            {/* <media-pip-button></media-pip-button> */}
            {/* <media-current-time-display></media-current-time-display>
          <media-duration-display></media-duration-display>
          <media-captions-button></media-captions-button> */}
          </media-control-bar>

          <media-control-bar
            class="mobile"
            style={{ background: "linear-gradient(180deg, transparent, #000)" }}
          >
            {/* slot="top-chrome" className="mobile" slot="top-chrome" */}
            <media-mute-button></media-mute-button>
            <media-volume-range></media-volume-range>
            <media-time-range
              class={`${!showBookmarkBar ? "" : "d-none"}`}
            ></media-time-range>

            <div
              className={"cursor-pointer"}
              onClick={() => setShowRemaining((prev) => !prev)}
            >
              {!showRemaining ? (
                <media-time-display
                  show-duration
                  class={`${!showBookmarkBar ? "" : "d-none"}`}
                ></media-time-display>
              ) : (
                <media-time-display
                  remaining
                  class={`${!showBookmarkBar ? "" : "d-none"}`}
                ></media-time-display>
              )}
            </div>
            {/* <span className={playerTheme["control-spacer"]}></span> */}
            {/* <button
            className={playerTheme["note-btn"]}
            style={{
              backgroundColor: isSidePanelOpen ? "#fff" : "transparent",
              color: isSidePanelOpen ? "#000" : "#fff",
            }}
            onClick={handleNoteBtn}
          >
            Notes
          </button> */}
            {/* <media-playback-rate-button
              rates={`1,1.25,1.5,1.75,2`}
            ></media-playback-rate-button> */}

            <img
              src={settingIcon}
              alt="setting"
              onClick={() => setOpenSettings((prev) => !prev)}
              className={playerTheme.settingsIcon}
            />

            <button id="subtitles" type="button" data-state="subtitles">
              CC
            </button>

            {/* <media-pip-button></media-pip-button> */}
            <media-fullscreen-button
              onClick={handleFullScreenButton}
            ></media-fullscreen-button>
            {/* <media-current-time-display></media-current-time-display>
          <media-duration-display></media-duration-display>
          <media-captions-button></media-captions-button> */}
          </media-control-bar>

          {/* {muxVideoRef &&
            muxVideoRef.current.duration &&
            allChapters &&
            allChapters.length > 0 && (
              <media-control-bar style={{ backgroundColor: "#000" }}>
                <div className={playerTheme.videoBigTimeLine}>
                  {allChapters.map((segment, index) =>
                    getVideoBigSegment(segment, index)
                  )}
                </div>
              </media-control-bar>
            )} */}

          <button
            ref={skipBtnRef}
            onClick={handleSkipBtn}
            className={`btn ${playerTheme.skipBtn}`}
          >
            {globalDocflixConstant?.videos?.skipBtnText || "Skip"}
          </button>
          <button
            ref={outroBtnRef}
            onClick={handleOutroBtn}
            style={{ pointerEvents: "none" }}
            className={`btn ${playerTheme.skipBtn}`}
          >
            {globalDocflixConstant?.videos?.outroBtnText || "Skip"}
          </button>
        </>
      ) : themeType === THEME.EVENT_THEME ? (
        <>
          <media-control-bar class="desktop">
            <div className={`w-100 ${playerTheme["event-container"]}`}>
              <span className="f-left">
                <media-mute-button></media-mute-button>
                <media-volume-range></media-volume-range>
              </span>
              {/* <span className={playerTheme["event-play-btn"]}>
              <media-play-button></media-play-button>
            </span> */}
              <span className={`f-right ${playerTheme["fullScreenContainer"]}`}>
                <div className={"live-text"}>
                  <span
                    className="liveDot"
                    style={{ backgroundColor: "var(--primary-color2)" }}
                  ></span>
                  &nbsp; Live
                </div>
                <media-fullscreen-button onClick={handleFullScreen}>
                  {/* <svg slot="enter"></svg> */}
                  {/* <svg slot="exit"></svg> */}
                </media-fullscreen-button>
              </span>
            </div>
            {/* <span className={playerTheme["control-spacer"]}></span> */}
            {/* <span className={playerTheme["control-spacer"]}></span> */}
          </media-control-bar>
          <media-control-bar
            class="mobile"
            style={{ background: "linear-gradient(180deg, transparent, #000)" }}
          >
            <media-mute-button></media-mute-button>
            <media-volume-range></media-volume-range>
            <span className={playerTheme["control-spacer"]}></span>
            <div className={playerTheme["fullScreenContainerMobile"]}>
              <div className={"live-text"} style={{ paddingRight: "1rem" }}>
                <span
                  className="liveDot"
                  style={{ backgroundColor: "var(--primary-color2)" }}
                ></span>
                &nbsp; Live
              </div>

              <media-fullscreen-button
                onClick={handleFullScreenButton}
              ></media-fullscreen-button>
            </div>
          </media-control-bar>
        </>
      ) : themeType === THEME.MANKIND_STANDALONE_THEME ? (
        <>
          <media-control-bar class="desktop">
            <media-play-button></media-play-button>
            <media-time-range></media-time-range>
            <media-mute-button></media-mute-button>
            <media-volume-range></media-volume-range>
            <media-fullscreen-button></media-fullscreen-button>
          </media-control-bar>
          <media-control-bar class="mobile">
            <media-control-bar class="w-100">
              <media-time-range></media-time-range>
            </media-control-bar>
            <span className="f-left">
              <media-play-button></media-play-button>
            </span>
            <span className="f-right">
              <media-mute-button></media-mute-button>
              <media-volume-range></media-volume-range>
              <media-fullscreen-button></media-fullscreen-button>
            </span>
          </media-control-bar>
        </>
      ) : null}
      {themeType !== THEME.DOUCUMENTARY_THEME && (
        <VideoSpeedController
          isOpen={openSettings}
          currentRate={currentRate}
          updateRate={updateRate}
          toggleSettings={toggleSettings}
        />
      )}
    </media-controller>
  );
};

export default memo(MuxVideoPlayer);
